import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementWorkRequestExhibitTypeComponent } from './case-management-work-request-exhibit-type.component';

const routes: Routes = [{ path: '', component: CaseManagementWorkRequestExhibitTypeComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementWorkRequestExhibitTypeRoutingModule { }
